import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PSIcon from '../../PSIcon';

import './index.scss';

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const dataFaqs = useSelector((state) => state.auth.faqs);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-section">
      {/* Columna izquierda */}
      <div className="faq-section__intro">
        <h2 className="faq-section__intro--title">¿Tiene dudas?</h2>
        <p className="faq-section__intro--desc">
          Consulte esta sección para aclarar las preguntas más frecuentes relacionadas con su
          póliza, el valor cuota, la rentabilidad y otros aspectos de su producto.
        </p>
      </div>

      {/* Columna derecha */}
      <div className="faq-section__list">
        {dataFaqs.map((faq, index) => (
          <div key={faq.orden} className="faq-section__list--item">
            <button type="button" onClick={() => toggleFAQ(index)}>
              <div className="item-container">
                <div className="item-question" dangerouslySetInnerHTML={{ __html: faq.pregunta }} />
                <span className="text-orange-500">
                  {openIndex === index ? (
                    <PSIcon type="arrowDownOrange" className="icon-svg" />
                  ) : (
                    <PSIcon type="arrowDownOrange" className="icon-svg" />
                  )}
                </span>
              </div>
            </button>
            {openIndex === index && (
              <div className="item-response" dangerouslySetInnerHTML={{ __html: faq.respuesta }} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqSection;
